import { get } from './';

export const getAccommodations = () => get('/api/v1/your_accommodations');

export const getAccommodation = ({ id, language }) =>
  get(`/api/v1/your_accommodations/${id}`, { lang: language,
});